module.exports = __webpack_public_path__ + "fonts/SuisseIntlCondensed-RegItalic.c1922ba.woff2";